'use client';
import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import ChartJS from '../ChartJS.js';
import 'classnames';
import '../../../server-components/Table/components/HeaderCell.module.scss.js';
import Flex from '../../../server-components/layout/Flex/Flex.js';
import '../../../server-components/layout/Row/Row.module.scss.js';
import '../../../server-components/layout/Stack/Stack.js';
import '../../../server-components/layout/Box/Box.js';
import '../../../server-components/icons/ActivityIcon.js';
import '../../../server-components/icons/ArrowDownIcon.js';
import '../../../server-components/icons/ArrowDownRightCircleIcon.js';
import '../../../server-components/icons/ArrowLeftAlignIcon.js';
import '../../../server-components/icons/ArrowLeftIcon.js';
import '../../../server-components/icons/ArrowRightAlignIcon.js';
import '../../../server-components/icons/ArrowRightIcon.js';
import '../../../server-components/icons/ArrowUpIcon.js';
import '../../../server-components/icons/ArrowUpRightCircleIcon.js';
import '../../../server-components/icons/ArrowsAngleExpandIcon.js';
import '../../../server-components/icons/BankIcon.js';
import '../../../server-components/icons/CheckIcon.js';
import '../../../server-components/icons/ChevronDownIcon.js';
import '../../../server-components/icons/ChevronRightIcon.js';
import '../../../server-components/icons/ChevronUpIcon.js';
import '../../../server-components/icons/CopyIcon.js';
import '../../../server-components/icons/CrossIcon.js';
import '../../../server-components/icons/DaiIcon.js';
import '../../../server-components/icons/DangerIcon.js';
import '../../../server-components/icons/DownSortIcon.js';
import '../../../server-components/icons/ExclamationTriangleIcon.js';
import '../../../server-components/icons/ExpandKpiIcon.js';
import '../../../server-components/icons/EyeIcon.js';
import '../../../server-components/icons/EyeSlashIcon.js';
import '../../../server-components/icons/Grid1x2Icon.js';
import '../../../server-components/icons/InfoCircleIcon.js';
import '../../../server-components/icons/ListIcon.js';
import '../../../server-components/icons/LockIcon.js';
import '../../../server-components/icons/MediumIcon.js';
import '../../../server-components/icons/MoonIcon.js';
import '../../../server-components/icons/PiggyBankIcon.js';
import '../../../server-components/icons/QuestionMarkCircleIcon.js';
import '../../../server-components/icons/ShieldIcon.js';
import '../../../server-components/icons/SunIcon.js';
import '../../../server-components/icons/UpSortIcon.js';
import '../../../server-components/icons/XIcon.js';
import '../../../server-components/Table/Table.module.scss.js';
import '../../../server-components/Table/components/TableRow.module.scss.js';
import '../../../server-components/Table/components/Pagination.module.scss.js';
import '../../../server-components/Text/Text.js';
import '../../../server-components/Table/components/TableCell/TableCell.module.scss.js';
import '../../../server-components/Card/Card.module.scss.js';
import '../../../server-components/List/List.module.scss.js';
import '../../../server-components/ErrorBox/ErrorBox.module.scss.js';
import '../../../server-components/InfoBox/InfoBox.module.scss.js';
import '../../../server-components/KpiCard/KpiCard.module.scss.js';
import '../../../server-components/TrendValue/TrendValue.module.scss.js';
import '../../../server-components/Modal/Modal.module.scss.js';
import '../../ThemeProvider.js';
import '../../Tabs/Tabs.module.scss.js';
import '../../ThemeModeSelector/ThemeModeSelector.module.scss.js';
import useThemeCustomProperties from '../../../../hooks/useThemeCustomProperties.js';
import '../../ExpandableCard/ExpandableCard.module.scss.js';
import '../../ExpandableKpiCard/ExpandableKpiCard.module.scss.js';
import '../../CopyButton/CopyButton.module.scss.js';
import 'ethereum-blockies-base64';
import 'luxon';
import '../../WalletAddress/WalletAddress.module.scss.js';
import '../../filters/TextSearchFilter/TextSearchFilter.module.scss.js';
import '@blockanalitica/ui';
import '../../sidebars/FixedSidebar/components/MobileTopNavBar/MobileTopNavbar.module.scss.js';
import '../../sidebars/FixedSidebar/components/Sidebar/Sidebar.module.scss.js';
import '../../sidebars/FixedSidebar/FixedSidebar.module.scss.js';
import '../../sidebars/CollapsableSidebar/CollapsableSidebar.module.scss.js';
import '../../FormattedCurrency/FormattedCurrency.js';
import '../../FormattedPercentage/FormattedPercentage.js';
import '../../CurrencyValue/CurrencyValue.module.scss.js';
import '../../PercentageValue/PercentageValue.module.scss.js';
import '../../DisplaySwitch/DisplaySwitch.module.scss.js';
import '../../Tooltip/Tooltip.js';
import _ from 'lodash';
import '../components/ChartKpis/ChartKpis.module.scss.js';
import '../components/ChartSingleValueIndicator/ChartSingleValueIndicator.module.scss.js';
import '../BarChart/BarChart.module.scss.js';
import '../LineChart/LineChart.module.scss.js';
import '../AreaChart/AreaChart.module.scss.js';
import 'randomcolor';
import 'd3';
import '../../Checkbox/Checkbox.module.scss.js';
import '../../../server-components/Badge/Badge.module.scss.js';
import '../../../server-components/HeatmapActivity/HeatmapActivity.module.scss.js';
import '../../../server-components/Switch/Switch.module.scss.js';
import '../../../server-components/Select/Select.module.scss.js';
import '../../../server-components/pictograms/EthPictogram.js';
import '../../../server-components/pictograms/EtherScanPictogram.js';
import '../../../server-components/pictograms/DebankPictogram.js';
import '../../../server-components/pictograms/ZapperPictogram.js';
import '../../../server-components/pictograms/DaiPictogram.js';
import 'react-loading-skeleton';

function DoughnutChart({ data, config }) {
    const colors = useThemeCustomProperties(['color-text', 'color-surface']);
    const mergedConfig = useMemo(() => {
        const defaultConfig = {
            type: 'doughnut',
            data: data,
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        display: true,
                        position: 'bottom',
                        labels: {
                            usePointStyle: true,
                            pointStyle: 'circle',
                            color: colors.colorText
                        }
                    },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                let label = context.label || '';
                                if (label) {
                                    label += ': ';
                                }
                                if (context.parsed !== null) {
                                    label += (config === null || config === void 0 ? void 0 : config.valueFormatter)
                                        ? config.valueFormatter(context.parsed)
                                        : context.parsed;
                                }
                                return label;
                            }
                        }
                    }
                }
            }
        };
        return _.merge(defaultConfig, config);
    }, [data, colors.colorText, config]);
    return (jsx(Flex, { direction: "column", gap: "space-xs", children: jsx(ChartJS, { config: mergedConfig }) }));
}

export { DoughnutChart as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
